import React from 'react';
import { Input } from '../../Input';
import { Select } from '../../Select';
import { DOSAGE_UNITS, DosageUnit } from '../../../types/data';

interface DosageEditorProps {
  dosage: number;
  dosageUnits: Unit;
  handleCloseModal: () => void;
  onChange: (dosage: number, units: Unit) => void;
}

export function DosageEditor({ dosage, dosageUnits, onChange, handleCloseModal }: DosageEditorProps) {
  const [localDosage, setLocalDosage] = React.useState(dosage);
  const [localUnits, setLocalUnits] = React.useState(dosageUnits);

  const handleSave = () => {
    onChange(localDosage, localUnits);
    handleCloseModal();
  };

  return (
    <>
        <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="Dosage Amount"
            type='number'
            value={localDosage}
            required={true}
            tooltip="Enter the desired amount of peptide to administer per dose."
            onChange={(value) => setLocalDosage(value as number)}
          // error={errors.vialAmount}
          />
          <Select
            label="Dosage Units"
            value={localUnits}
            required={true}
            tooltip="Select the measurement units for your dosage."
            onChange={(value) => setLocalUnits(value as DosageUnit)}
            options={DOSAGE_UNITS}
          />
        </div>
          <button
            onClick={handleSave}
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Save Changes
          </button>
        </div>
    </>
  );
}